export default "__VITE_ASSET__$nKNsPJX__"